import { useRef, useState, useEffect } from 'react';

const useAutoNavigation = ({
  autoNavigationDelay,
  carouselContainerRef,
  currentSelection,
  length,
  scrollToSlide,
  setCurrentSelection,
  setHasBeenInteracted
}) => {
  const autoNavigationTimeoutRef = useRef(null);
  const [isAutoNavigatingActive, setIsAutoNavigatingActive] = useState(!!autoNavigationDelay);
  const ariaLive = isAutoNavigatingActive ? "off" : "polite";
  useEffect(() => {
    setIsAutoNavigatingActive(!!autoNavigationDelay);
  }, [autoNavigationDelay]);
  useEffect(() => {
    const resetAutoNavigationTimeout = () => {
      if (autoNavigationTimeoutRef.current) {
        clearTimeout(autoNavigationTimeoutRef.current);
      }
    };
    resetAutoNavigationTimeout();
    if (isAutoNavigatingActive) {
      autoNavigationTimeoutRef.current = setTimeout(() => {
        const nextSlide = currentSelection === length - 1 ? 0 : currentSelection + 1;
        setCurrentSelection(nextSlide);
        scrollToSlide(nextSlide);
        setHasBeenInteracted(true);
      }, autoNavigationDelay);
    }
    return () => {
      resetAutoNavigationTimeout();
    };
  }, [
    autoNavigationDelay,
    scrollToSlide,
    currentSelection,
    isAutoNavigatingActive,
    length,
    setCurrentSelection,
    setHasBeenInteracted
  ]);
  useEffect(() => {
    const currentCarouselContainer = carouselContainerRef.current;
    const disableAutoNavigation = () => {
      setIsAutoNavigatingActive(false);
    };
    const enableAutoNavigation = () => {
      setIsAutoNavigatingActive(true);
    };
    if (autoNavigationDelay) {
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.addEventListener("mouseover", disableAutoNavigation);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.addEventListener("focusin", disableAutoNavigation);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.addEventListener("touchstart", disableAutoNavigation);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.addEventListener("mouseleave", enableAutoNavigation);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.addEventListener("focusout", enableAutoNavigation);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.addEventListener("touchend", enableAutoNavigation);
    }
    return () => {
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.removeEventListener("mouseover", disableAutoNavigation);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.removeEventListener("focusin", disableAutoNavigation);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.removeEventListener("touchstart", disableAutoNavigation);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.removeEventListener("mouseleave", enableAutoNavigation);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.removeEventListener("focusout", enableAutoNavigation);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.removeEventListener("touchend", enableAutoNavigation);
    };
  }, [autoNavigationDelay, carouselContainerRef]);
  return { ariaLive, isAutoNavigatingActive };
};

export { useAutoNavigation as default };
//# sourceMappingURL=useAutoNavigation.es.js.map
